import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-menu-trainings",
  "use": "icon-menu-trainings-usage",
  "viewBox": "0 0 18 16",
  "content": "<symbol viewBox=\"0 0 18 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-menu-trainings\">\n<path d=\"M14.8333 8.69853V10.1306C14.8333 13.3523 12.2216 15.964 9 15.964C5.7783 15.964 3.16663 13.3523 3.16663 10.1306V8.69853L8.46567 11.2043C8.80392 11.3642 9.19609 11.3642 9.53442 11.2043L14.8333 8.69853ZM9.53442 0.723735L17.1013 4.3019C17.7126 4.59094 17.7899 5.38717 17.3333 5.8045V9.29728C17.3333 9.75753 16.9602 10.1306 16.5 10.1306C16.0398 10.1306 15.6667 9.75753 15.6667 9.29728V6.63772L9.53442 9.53745C9.19609 9.69745 8.80392 9.69745 8.46567 9.53745L0.898711 5.95928C0.198952 5.62839 0.198977 4.63278 0.898711 4.3019L8.46567 0.723735C8.80392 0.563768 9.19609 0.563768 9.53442 0.723735Z\" fill=\"#314455\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/svgIcon/svg/menu-trainings.svg
// module id = BRlw
// module chunks = 258